import { cn } from "@/lib/utils";
import { ALERT_LEVEL } from "@/lib/status";
import { Panel } from "@/components/common/Panel";
import { EmptyState } from "@/components/common/States";
import { ShieldCheck } from "lucide-react";

export const AlertsPanel = ({ alertes }) => (
  <Panel title="Alertes temps réel" subtitle={`${alertes.length} active${alertes.length > 1 ? "s" : ""}`} testId="alerts-panel" bodyClassName="max-h-72 overflow-auto">
    {alertes.length === 0 ? <EmptyState icon={ShieldCheck} title="Aucune alerte" hint="Toutes les lignes sont dans les seuils (TRS ≥ 60 %, Perf ≥ 70 %, Qualité ≥ 95 %, rejets ≤ 5 %)." /> : (
      <ul className="divide-y divide-border/60">
        {alertes.map((a, i) => {
          const l = ALERT_LEVEL[a.niveau] || ALERT_LEVEL.orange;
          return (
            <li key={i} data-testid={`alert-item-${i}`} className="relative pl-4 pr-3 py-2 flex items-start gap-3 text-xs hover:bg-accent/30">
              <span className={cn("status-stripe", l.stripe)} />
              <span className={cn("font-mono text-[10px] uppercase w-16 shrink-0 mt-0.5", l.text)}>{l.label}</span>
              <span className="font-semibold w-28 shrink-0 truncate">{a.ligne}</span>
              <span className="text-muted-foreground">{a.texte}</span>
            </li>
          );
        })}
      </ul>
    )}
  </Panel>
);
